<template>
	<div class="row m-0">
		<page-title :title="$t('resetForgottenPassword')" :showTitle="false"></page-title>
		<div class="col-sm-8 col-md-6 col-lg-4 mx-auto mt-5">
			<div class="loader" v-if="loading"></div>
			<div v-if="!loading" class="card">
				<div class="card-header bg-primary text-white">
					<div class="card-title h5 m-0">{{ $t('resetForgottenPassword') }}</div>
				</div>
				<div class="card-body">
					<div>
						<div class="form-group">
							<label for="email" class="required">{{ $t('email') }}</label>
							<input id="email" type="email" class="form-control" name="email" :data-vv-as="$t('email')" v-model="email" v-validate="'required|email'" />
							<span class="text-danger">{{ errors.first('email') }}</span>
						</div>
						<div class="form-group">
							<label for="newPassword" class="required">{{ $t('changePassword.newPassword') }}</label>
							<input
								id="newPassword"
								type="password"
								class="form-control"
								ref="passwordRef"
								name="newPassword"
								:data-vv-as="$t('changePassword.newPassword')"
								v-model="newPassword"
								v-validate="'required|upCaseNum'"
							/>
							<span class="text-danger">{{ errors.first('newPassword') }}</span>
						</div>
						<div class="form-group">
							<label for="newPasswordConfirm" class="required">{{ $t('changePassword.newPasswordConfirm') }}</label>
							<input
								id="newPasswordConfirm"
								type="password"
								class="form-control"
								name="newPasswordConfirm"
								:data-vv-as="$t('changePassword.newPasswordConfirm')"
								v-model="newPasswordConfirm"
								v-validate="`required|confirmPass:${newPassword}`"
								@keyup.enter="resetPassword"
							/>
							<span class="text-danger">{{ errors.first('newPasswordConfirm') }}</span>
						</div>

						<div>
							<button class="btn btn-primary float-right" @click="resetPassword" :disabled="loading">{{ $t('resetPassword') }}</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import authService from '../../services/auth.service';
import PageTitle from '../../components/common/PageTitle';

export default {
	components: {
		PageTitle
	},
	data: function() {
		return {
			token: null,
			email: '',
			newPassword: '',
			newPasswordConfirm: '',
			loading: false
		};
	},
	computed: {},
	mounted() {
		this.token = this.$route.query.token;
	},
	methods: {
		resetPassword() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.loading = true;
					authService
						.resetPassword({
							token: this.token,
							email: this.email,
							newPassword: this.newPassword,
							newPasswordConfirm: this.newPasswordConfirm
						})
						.then(data => {
							this.loading = false;
							this.$store.dispatch('setUserData', data);
							this.$router.push({ path: '/' });
						})
						.catch(error => {
							this.loading = false;
							this.$vs.notify({
								title: this.$t(
									'request.response.status.' +
										this.$helpers.errorStatusCode(error)
								),
								text: this.$helpers.errorText(error),
								color: 'danger',
								time: this.$store.getters.notificationDuration
							});
						});
				}
			});
		}
	}
};
</script>
